module.exports = __webpack_public_path__ + "assets/images/thumbnail-2fea79ebb0f4bc93d11b39583e114c63.jpg";